import { History } from "history";
import { combineReducers } from "redux";
import { routerReducer, RouterState } from "react-router-redux";

import * as dataSourceTypes from "./dataSource/types";
import * as dataSourceReducers from "./dataSource/reducer";

import * as spokeTypes from "./spokes/types";
import * as spokeReducers from "./spokes/reducer";

import * as dataTargetTypes from "./dataTarget/types";
// import * as dataTargetReducers from "./dataTarget/reducer";

import { SchemaSelectionState } from "./schemaSelection/types";
import { SchemaSelectionReducer } from "./schemaSelection/reducer";

import GroupsReducer from "./groups/reducer";
import { GroupState } from "./groups/types";

import * as overrideTypes from "./roleOverRide/types";
import * as overrideReducers from "./roleOverRide/reducer";

import * as targetTypes from "./dataTarget/types";
import * as targetReducers from "./dataTarget/reducer";

import * as loaderTypes from "./dataLoader/types";
import * as loaderReducers from "./dataLoader/reducer";

import * as extractorReducers from "./extractor/reducer";
import * as extractorTypes from "./extractor/types";

import * as taskTypes from "./eventBasedTrigger/types";
import * as taskReducers from "./eventBasedTrigger/reducer";

import * as profileTypes from "./userProfile/types";
import * as profileReducers from "./userProfile/reducer";

import * as jobTypes from "./timeBasedTrigger/types";
import * as jobReducers from "./timeBasedTrigger/reducer";

import * as webhookTypes from "./webhooks/types";
import * as webhookReducers from "./webhooks/reducer";

import * as insituExtractorTypes from "./insituExtractor/types"
import * as insituExtractorReducers from "./insituExtractor/reducer";

import * as overrideRequestTypes from "./requestOverride/types";
import * as overrideRequestReducers from "./requestOverride/reducer";


import { NotificationState } from "./alert/types";
import NotificationReducer from "./alert/reducer";

import {
  IPostMetaDataExtractorState,
  IPutExtractorMetadataState,
} from "./extractor/metaData/types";
import {
  EXTTableMetaDataReducer,
  FoundryMetaDataReducer,
  PostMetaDataExtractorReducer,
  PutMetaDataExtractorReducer,
} from "./extractor/metaData/reducer";

import {
  ICustomExtState,
  IDBExtState,
  IPatternsState,
} from "./extractor/types";

import {
  CustExtReducer,
  DBExtReducer,
  PatternsReducer,
} from "./extractor/reducer";

import { IAuthState } from "./auth/types";
import { UserAuthReducer } from "./auth/reducer";

import {
  IExtJobScheduleState,
  IPutJobSchedulesState,
  IDeleteJobSchedulesState,
} from "./jobSchedules/types";
import {
  ExtJobSchedulesReducer,
  PutJobSchedulesReducer,
  DeleteJobSchedulesReducer,
} from "./jobSchedules/reducer";

import { IWorkflowState } from "./workFlows/types";
import { WorkFlowsReducer } from "./workFlows/reducer";

import { IPostTaskConnectionState } from "./eventBasedTrigger/types";
import { PostTaskConnectionReducer } from "./eventBasedTrigger/reducer";

import { IDeleteSubscriptionState } from "./subscriptions/types";
import { DeleteSubscriptionReducer } from "./subscriptions/reducer";

import { IPostSubscriptionState } from "./subscriptions/types";
import { PostSubscriptionReducer } from "./subscriptions/reducer";

import { IPostExtractorSubscriptionState } from "./subscriptions/types";
import { PostExtractorSubscriptionReducer } from "./subscriptions/reducer";

import { FetchSubscriptionState } from "./subscriptions/types";
import { SubscriptionDetailsReducer } from "./subscriptions/reducer";

import {
  IEventTriggersState,
  IPutEventsState,
  IDeleteEventsState,
} from "./events/types";
import {
  EventTriggerReducer,
  PutEventsReducer,
  DeleteEventsReducer,
} from "./events/reducer";

import { IInboundWebhookState } from "./webhooks/types";
import { InboundWebhookReducer } from "./webhooks/reducer";

import { IDeleteSpokeState } from "./spokes/types";
import { DeleteSpokeReducer } from "./spokes/reducer";

import { IOutboundWebhookState, IDeleteOutboundState } from "./webhooks/types";
import {
  OutboundWebhookReducer,
  DeleteOutboundReducer,
} from "./webhooks/reducer";

import { IDataProvisioningWorkflowState } from "./dataProvisioningWorkflow/types";
import { DataProvisioningWorkflowReducer } from "./dataProvisioningWorkflow/reducer";

export interface RootState {
  profile: profileTypes.IProfileState;
  postTaskConnection: IPostTaskConnectionState;
  taskConnection: taskTypes.ITaskConnectionState;
  fetchSpokes: spokeTypes.FetchSpokeState;
  spokeList: spokeTypes.FetchSpokeListState;
  deleteSubscription: IDeleteSubscriptionState;
  fetchSubscription: FetchSubscriptionState;
  postSubscription: IPostSubscriptionState;
  postExtractorSubscription: IPostExtractorSubscriptionState;
  routerReducer: RouterState;
  accessControl: dataSourceTypes.IAccessControlState;
  user: IAuthState;
  groupsReducer: { [group: string]: GroupState };
  steward: dataSourceTypes.IStewardState;
  connectionReducer: dataSourceTypes.IPostConnectionState;
  sources: dataSourceTypes.SourceListState;
  sourceDetails: dataSourceTypes.SourceState;
  postDataSource: dataSourceTypes.IPostDataSourceState;
  putDataSource: dataSourceTypes.IPutDataSourceState;
  deleteDataSource: dataSourceTypes.IDeleteDataSourceState;
  schemaReducer: SchemaSelectionState;
  targets: targetTypes.TargetListState;
  targetDetails: targetTypes.ITargetState;
  postDataTarget: dataTargetTypes.IPostDataTargetState;
  putDataTarget: dataTargetTypes.IPutDataTargetState;
  postSpoke: spokeTypes.IPostSpokeState;
  putEvents: IPutEventsState;
  deleteDataTarget: dataTargetTypes.IDeleteDataTargetState;
  deleteSpoke: IDeleteSpokeState;
  taskId: taskTypes.IPostTaskState;
  getLoaders: taskTypes.ILoaderListState;
  extractors: extractorTypes.ExtractorListState;
  extractorDetail: extractorTypes.IExtractorDetailState;
  extractorStatus: extractorTypes.IExtractorStatusState;
  putExtractor: extractorTypes.IPutExtractorState;
  deleteExtractor: extractorTypes.IDeleteExtractorState;
  tasks: taskTypes.TaskListState;
  putTask: taskTypes.IPutTaskState;
  eventTasks: taskTypes.EventTaskListState;
  events: taskTypes.EventListState;
  deleteEvents: IDeleteEventsState;
  deleteOutbound: IDeleteOutboundState;
  inboundEvents: taskTypes.InboundListState;
  outboundEvents: taskTypes.OutboundListActions;
  jobs: jobTypes.JobListState;
  putInbound: webhookTypes.IPutInboundState;
  putOutbound: webhookTypes.IPutOutboundState;
  inboundWebhook: IInboundWebhookState;
  deleteJobSchedules: IDeleteJobSchedulesState;
  outboundWebhook: IOutboundWebhookState;
  outboundWebhookList: webhookTypes.OutboundWebhookListState;
  notifications: NotificationState;
  patterns: IPatternsState;
  metadataPostExtractorReducer: IPostMetaDataExtractorState;
  metaDataPutExtractorReducer: IPutExtractorMetadataState;
  putJobSchedules: IPutJobSchedulesState;
  metadetaCustExtReducer: ICustomExtState;
  metaDataPostDBExtReducer: IDBExtState;
  extMetaDataTableReducer: IDBExtState;
  postJobSchedules: IExtJobScheduleState;
  workFlowPostReducer: IWorkflowState;
  eventTriggerPostReducer: IEventTriggersState;
  dataProvisioningWorkflow: IDataProvisioningWorkflowState;
  loaders: loaderTypes.LoaderListState;
  loaderStatus: loaderTypes.ISingleLoaderStatus;
  loaderDetails: loaderTypes.LoaderDetailsState;
  overrides: overrideTypes.OverrideListState;
  overrideDetails: overrideTypes.OverrideState;
  postDataOverride: overrideTypes.IPostOverrideState;
  putDataOverride: overrideTypes.IPutOverrideState;
  deleteDataOverride: overrideTypes.IDeleteOverrideState;
  insituExtractors: insituExtractorTypes.InsituExtractorListState;
  insituExtractorDetails: insituExtractorTypes.IInsituExtractorDetails;
  postInsituExtractor: insituExtractorTypes.IPostInsituExtractorState;
  putInsituExtractor: insituExtractorTypes.IPutInsituExtractorState;
  overrideRequests: overrideRequestTypes.OverrideRequestListState;
}

const rootReducer = combineReducers({
  profile: profileReducers.ProfileReducer,
  postTaskConnection: PostTaskConnectionReducer,
  taskConnection: taskReducers.TaskConnectionReducer,
  fetchSpokes: spokeReducers.SpokesDetailsReducer,
  spokeList: spokeReducers.SpokesListDetailsReducer,
  fetchSpokeById: spokeReducers.SpokesDetailsByIdReducer,
  routerReducer,
  deleteSubscription: DeleteSubscriptionReducer,
  postSubscription: PostSubscriptionReducer,
  postExtractorSubscription: PostExtractorSubscriptionReducer,
  fetchSubscription: SubscriptionDetailsReducer,
  accessControl: dataSourceReducers.AccessControlReducer,
  user: UserAuthReducer,
  groupsReducer: GroupsReducer,
  steward: dataSourceReducers.StewardReducer,
  connection: dataSourceReducers.PostConnectionReducer,
  sources: dataSourceReducers.SourcesListReducer,
  sourceDetails: dataSourceReducers.SourceDetailsReducer,
  postDataSource: dataSourceReducers.PostDataSourceReducer,
  putDataSource: dataSourceReducers.PutDataSourceReducer,
  deleteDataSource: dataSourceReducers.DeleteSourceReducer,
  putEvents: PutEventsReducer,
  schemaReducer: SchemaSelectionReducer,
  taskId: taskReducers.PostTaskReducer,
  targets: targetReducers.TargetListReducer,
  deleteOutbound: DeleteOutboundReducer,
  targetDetails: targetReducers.TargetDetailsReducer,
  deleteSpoke: DeleteSpokeReducer,
  postDataTarget: targetReducers.PostDataTargetReducer,
  deleteJobSchedules: DeleteJobSchedulesReducer,
  putDataTarget: targetReducers.PutDataTargetReducer,
  putExtractor: extractorReducers.PutExtractorReducer,
  postSchemaExt: extractorReducers.PostSchemaExtReducer,
  retrySchemaUpdate: extractorReducers.PostRetrySchemaUpdateReducer,
  postSpoke: spokeReducers.PostSpokeReducer,
  putInbound: webhookReducers.PutInboundReducer,
  putOutbound: webhookReducers.PutOutboundReducer,
  deleteDataTarget: targetReducers.DeleteTargetReducer,
  getLoaders: taskReducers.LoaderListReducer,
  extractors: extractorReducers.ExtractorListReducer,
  extractorDetail: extractorReducers.ExtractorDetailReducer,
  extractorStatus: extractorReducers.ExtractorStatusReducer,
  deleteExtractor: extractorReducers.DeleteExtractorReducer,
  putJobSchedules: PutJobSchedulesReducer,
  deleteEvents: DeleteEventsReducer,
  tasks: taskReducers.TaskListReducer,
  putTask: taskReducers.PostTaskReducer,
  eventTasks: taskReducers.EventTaskListReducer,
  events: taskReducers.EventListReducer,
  inboundEvents: taskReducers.InboundListReducer,
  outboundEvents: taskReducers.OutboundListReducer,
  inboundWebhook: InboundWebhookReducer,
  outboundWebhook: OutboundWebhookReducer,
  jobs: jobReducers.JobListReducer,
  outboundWebhookList: webhookReducers.OutboundWebhookListReducer,
  notifications: NotificationReducer,
  patterns: PatternsReducer,
  metaDataPostExtractorReducer: PostMetaDataExtractorReducer,
  metaDataPutExtractorReducer: PutMetaDataExtractorReducer,
  metadetaCustExtReducer: CustExtReducer,
  metaDataPostDBExtReducer: DBExtReducer,
  extMetaDataTableReducer: EXTTableMetaDataReducer,
  foundryMetaDataReducer: FoundryMetaDataReducer,
  postJobSchedules: ExtJobSchedulesReducer,
  workFlowPostReducer: WorkFlowsReducer,
  eventTriggerPostReducer: EventTriggerReducer,
  dataProvisioningWorkflow: DataProvisioningWorkflowReducer,
  postDataLoader: loaderReducers.PostDataLoaderReducer,
  putDataLoader: loaderReducers.PutDataLoaderReducer,
  deleteDataLoader: loaderReducers.DeleteLoaderReducer,
  loaders: loaderReducers.LoadersListReducer,
  loaderStatus: loaderReducers.LoaderStatusReducer,
  loaderDetails: loaderReducers.LoaderDetailsReducer,
  overrides: overrideReducers.OverridesListReducer,
  overrideDetails: overrideReducers.OverrideDetailsReducer,
  postOverride: overrideReducers.PostOverrideReducer,
  putOverride: overrideReducers.PutOverrideReducer,
  deleteOverride: overrideReducers.DeleteOverrideReducer,
  insituExtractors: insituExtractorReducers.InsituExtractorListReducer,
  insituExtractorDetails: insituExtractorReducers.InsituExtractorDetailsReducer,
  postInsituExtractor: insituExtractorReducers.PostInsituExtractorReducer,
  putInsituExtractor: insituExtractorReducers.PutInsituExtractorReducer,
  deleteInsituExtractor: insituExtractorReducers.DeleteExtractorReducer,
  postOverrideRequest: overrideRequestReducers.PostOverrideRequestReducer,
  patchOverrideRequest: overrideRequestReducers.PatchOverrideRequestReducer,
  fetchOverrideRequest: overrideRequestReducers.OverrideRequestDetailsReducer,
  overrideRequests: overrideRequestReducers.OverrideRequestsListReducer,
});

export type AppState = ReturnType<typeof rootReducer>;

const RootReducer = (history: History) => rootReducer;

export default RootReducer;